/* eslint-disable @typescript-eslint/no-explicit-any */
import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { SuccessData } from 'types/api';
import { AddCountryRequest, Cost, Demographics, Project } from '../types';

export const projectCountryMutations = getMutations({
  answerProjectCountryAddition: {
    action: async (payload: {
      project: string;
      comment: string;
      allow: boolean;
      costs?: Record<string, Cost[]>;
      demographics?: Demographics;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: 'projects/review-country',

        payload,
      });
    },

    messages: {
      success: (t) => ({
        title: t('country-addition-reviewed'),
        type: 'success',
      }),

      error: (t) => ({
        title: t('error-while-reviewing-country-addition'),
        type: 'error',
      }),
    },
  },

  requestProjectCountryAddition: {
    action: async (payload: {
      project: string;
      servicesToInclude: string[];
      justification: string;
      country: string;
      demographicsComment: string;
    }): Promise<AddCountryRequest> => {
      return executeApiCall({
        path: '/projects/add-country',

        payload,
      });
    },

    messages: {
      error: (t) => ({
        title: t('error-while-adding-service'),
        type: 'error',
      }),
    },
  },

  finishProjectCountryAddition: {
    action: async (payload: {
      project: string;
      comment: string;
      approved: boolean;
    }): Promise<Partial<Project>> => {
      return executeApiCall({
        path: '/projects/consolidate-country',

        payload,
      });
    },

    messages: {
      error: (t) => ({
        title: t('country-addition-approval-send-successfully'),
        type: 'success',
      }),
    },
  },
});
